const data = {
	"body": "<path fill=\"currentColor\" d=\"M12 11a4 4 0 1 0-4-4a4 4 0 0 0 4 4Zm0-6a2 2 0 1 1-2 2a2 2 0 0 1 2-2Zm0 8a7 7 0 0 0-7 7a1 1 0 0 0 2 0a5 5 0 0 1 10 0a1 1 0 0 0 2 0a7 7 0 0 0-7-7Z\"/>",
	"width": 24,
	"height": 24
};
exports.__esModule = true;
exports.default = data;
